if (!customElements.get('bar-announcement')) {
  customElements.define('bar-announcement', class BarAnnouncement extends HTMLElement {
    constructor() {
      super();
      this.$messages = this.querySelectorAll('.bar-announcement__message');
      this.activeIndex = 0;
      this.messagesCount = this.$messages && this.$messages.length ? this.$messages.length : 0;
      this.$prevBtn = this.querySelector('.bar-announcement__btn--prev');
      this.$nextBtn = this.querySelector('.bar-announcement__btn--next');
      this.autoplay = this?.dataset?.autoplay ? parseInt(this.dataset.autoplay, 10) : false;
      this.autoplayInterval;

      if (!this.messagesCount) return;

      this.showMessage(0);

      if (this.autoplay) {
        this.startAutoplay();
      }

      if (this.$prevBtn && this.$nextBtn) {
        this.setupEventListeners();
      }
    }

    showMessage(index) {
      this.$messages.forEach(($message, messageIndex) => {
        if (index === messageIndex) {
          $message.classList.remove('bar-announcement__message--hidden');
          $message.setAttribute('aria-hidden', false);
        } else {
          $message.classList.add('bar-announcement__message--hidden');
          $message.setAttribute('aria-hidden', true);
        }
      });
      this.activeIndex = index;
    }

    previousMessage = () => {
      clearInterval(this.autoplayInterval);
      const newIndex = this.activeIndex - 1;
      if (newIndex < 0) {
        this.showMessage(this.messagesCount - 1)
      } else {
        this.showMessage(newIndex);
      }
    }

    nextMessage = () => {
      clearInterval(this.autoplayInterval);
      const newIndex = this.activeIndex + 1;
      if (newIndex > (this.messagesCount - 1)) {
        this.showMessage(0)
      } else {
        this.showMessage(newIndex);
      }
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextMessage, this.autoplay);
    }

    setupEventListeners() {
      this.$prevBtn.addEventListener('click', this.previousMessage);
      this.$nextBtn.addEventListener('click', this.nextMessage);
    }
  });
}
